import { Tabs,Tab } from "react-bootstrap";
import React, { useState } from 'react';
import { UrlPath } from "../../../config/routeConfig";
import { BreadCrumbs } from "../../shared/breadCrumbs/BreadCrumbs"
import { TopBar } from "../../shared/topBar/TopBar";
import FeesTab from "./Tab/FeesTab/FeesTab";
import SetupTab from "./Tab/SetuptTab/SetupTab";
import BillingTab from "./Tab/BillingTab/BillingTab";
import { useEffect } from "react";
import { ToastContainer } from "react-toastify";
// Billing Tab 


export const Billing = () => {
    const Level = [{ BreadCrumb: "Admin >", Routes: `${UrlPath.Admin}` }, { BreadCrumb: "Billing", Routes: `${UrlPath.Billing}` }];
    const [activeTab,setActiveTab]=useState("Billing");
    useEffect(()=>{
        document.title="Billing";
    },[])
    return <>
        <TopBar label={"Billing"} />
        <div className="mainContentData">
            <BreadCrumbs Levels={Level} />
            <div className="container-fluid p-4 ">
            <Tabs activeKey={activeTab} onSelect={(key)=>{setActiveTab(key)}}>
                <Tab className="life-science rounded  border-top-0 "  eventKey="Billing" title="Billing" >
                 {activeTab==="Billing" &&<BillingTab/>}
                </Tab>
                <Tab  className="life-science rounded  border-top-0" eventKey="Fees" title="Fees">
                {activeTab==="Fees" && <FeesTab/>}
                </Tab>
                <Tab className="life-science rounded  border-top-0" eventKey="SetUp" title="Setup">
                {activeTab==="SetUp" && <SetupTab/>}
                </Tab>
            </Tabs>
            </div>
        </div>
        <ToastContainer/>
    </>
};
